import { dontUpsell } from '@trello/config';
import {
  useUpgradePromptDismissMessageMutation,
  useUpgradePromptQuery,
} from '@trello/graphql/generated';
import { useState } from 'react';

// UpgradePrompt display state logic
export const useUpgradePrompt = (orgId: string, messageId: string) => {
  // Apollo hooks
  const { data } = useUpgradePromptQuery({
    variables: {
      memberId: 'me',
      orgId,
    },
  });
  const [
    addOneTimeMessagesDismissed,
  ] = useUpgradePromptDismissMessageMutation();

  const isFreeTeam = Boolean(
    data && data.organization && !data.organization.products.length,
  );
  const isMessageDismissed = Boolean(
    data &&
      data.member &&
      data.member.oneTimeMessagesDismissed &&
      data.member.oneTimeMessagesDismissed.find((msgId) => msgId === messageId),
  );

  // Manual override to speed up hiding the prompt
  const [shouldHidePrompt, togglePrompt] = useState(false);

  const shouldDisplayUpgradePrompt =
    !dontUpsell && isFreeTeam && !shouldHidePrompt && !isMessageDismissed;

  return {
    dismissMessage() {
      addOneTimeMessagesDismissed({
        variables: {
          memberId: 'me',
          messageId,
        },
      });
    },
    hidePrompt() {
      togglePrompt(true);
    },
    shouldDisplayUpgradePrompt,
  };
};
